<template>
  <v-btn-form :title="title" :mode = "isLoaded" @close="cancel()">
    <v-flex v-if="fileItem" >
      <v-card flat>
        <v-card-title style="display: block; overflow-wrap: break-word;">
          <span class="headline">{{fileItem.docName}}</span>
          <v-component :is="renderDepoFileSignature(fileItem)"></v-component>
        </v-card-title>
        <v-card-text style="display: block; overflow-wrap: break-word;">
          <v-flex>
          Cсылка: <b><a :href="getUrl(fileItem.uid)">{{getUrl(fileItem.uid)}}</a></b>
          </v-flex>
          <v-flex>
          Депонировано: <b>{{formats.blank(fileItem.uploaded, formats.formatDateTime)}}</b> (по:&nbsp{{formats.blank(fileItem.deleted, formats.formatDate)}})
          </v-flex>
          <v-flex>
          Депонент: <b>{{fileItem.ownerShortName}}</b> ИНН: {{formats.formatInn(fileItem.ownerInn)}}
          </v-flex>
          <!-- michel 2025-06-27
          <v-flex>
          <b><a :href="getUrl(getOpenSettings.depoRules)">Правила Депонирования</a></b>
          </v-flex>
          -->
        </v-card-text>
      </v-card>
      <v-card v-if="history.length > 0">
        <v-panel-title @click="isLoaded=!isLoaded" :value="isLoaded" :caption="'История'" :expandable="true">
        <span>ВАЖНО! Депонент загрузил новые версии файла с момента депонирования, показана актуальная версия! Смотрите изменения в <a @click="isLoaded=true">истории</a>, рекомендуем <a @click="copyLink()">обновить ссылку</a>.</span>
        </v-panel-title>
        <v-card-text v-if="isLoaded" style="display: block; overflow-wrap: break-word;">
          <template v-for="item in history">
          <v-flex>
          Название: <b>{{item.docName}}</b>
          <v-component :is="renderDepoFileSignature(item)"></v-component>
          </v-flex>
          <v-flex>
          <span>
          Депонировано: <b>{{formats.blank(item.uploaded, formats.formatDateTime)}}</b> (по:&nbsp{{formats.blank(item.deleted, formats.formatDate)}})
          <v-btn small flat @click="open(item.uid)">Открыть</v-btn>
          </span>
          </v-flex>
          </template>
        </v-card-text>
      </v-card>
    </v-flex>
    <template #actions>
          <v-btn @click="open(fileItem.uid)">Открыть</v-btn>
          <v-component :is="createCopyButton('Ссылку', 'content_copy', 'Копировать ссылку', copyLink)" />
          <v-spacer></v-spacer>
    </template>

  </v-btn-form>
</template>

<script>
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import vPanelTitle from '../info/PanelTitle'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'doc-prop',
    components: {vPanelTitle, vBtnForm},
    mixins: [apimix],
    data: () => ({
      fileItems: [],
      isLoaded: false
    }),
    props: {
      toolbar: {
        type: Boolean,
        default: false
      },
      fileItemId: {
        type: String,
        default: null
      },
      mode: {
        type: String,
        default: null
      }
    },
    watch: {
      fileItemId: function (newVal, oldVal) { // watch it
        this.fetchData(newVal)
      }
    },
    computed: {
      ...mapGetters({
        getDepoFileProp: 'getDepoFileProp',
        getOpenSettings: 'getOpenSettings',
        renderDepoFileSignature: 'renderDepoFileSignature',
        getDepoUrl: 'getDepoUrl'
      }),
      title () {
        return 'Депонированный файл'
      },
      fileItem () {
        return this.fileItems.length > 0 ? this.fileItems[0] : null
      },
      history () {
        return this.fileItems.slice(1)
      }
    },
    methods: {
      fetchData (itemId) {
        if (itemId) {
          this.$store.dispatch('getDepoFileVersions', itemId).then(
            (fs) => {
              this.fileItems = fs
            },
            () => {})
        }
      },
      cancel () {
        this.edit = false
        this.$emit('close')
      },
      open (uid) {
        let url = this.getUrl(uid) + '/stream'
        this.$store.dispatch('openLocation', url)
      },
      getUrl (uid) {
        return this.getDepoUrl(uid)
      },
      copyLink () {
        this.$store.dispatch('copyDepoFileLink', this.getUrl(this.fileItem.uid))
      },
      createCopyButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<div><v-tooltip bottom open-delay="500">
            <div slot="activator">
              <v-btn  @click="action">
                <v-icon small>{{icon}}</v-icon>{{caption}}
              </v-btn>
            </div>
            <span>{{hint}}</span>
          </v-tooltip></div>`
        )
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action
            }
          }
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// DocProp.vue?36dd1f0f